import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  authRequired: false,
  gameListUrl: `api/site/pragmatic/gamelist?partner_name=${projectName}`,
  sessionUrlData: {
    url: 'pragmatic/game/link',
    method: QueryTypes.GET,
    getBody: params => ({
      game_id: params.gameId,
      platform: params.platform === 'desktop' ? 'web' : 'mobile',
      lang: shortLanguages[params.lang as keyof typeof shortLanguages],
    }),
    getHeaders: () => ({
      headers: {
        'x-actual-domain': process.env.NODE_ENV === 'production' ? `https://${location.host}/` : 'https://ganamos.net/',
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
    converter: converter.convertGameUrl,
  },
  converter,
};
